function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: "100%",
  height: "100%",
  fill: "transparent"
});

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(26.57 18)",
  clipPath: "url(#migrate_svg__a)"
}, /*#__PURE__*/React.createElement("clipPath", {
  id: "migrate_svg__a"
}, /*#__PURE__*/React.createElement("rect", {
  transform: "translate(-8.57)",
  x: -18,
  y: -18,
  rx: 0,
  ry: 0,
  width: 36,
  height: 36
})), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M-6.433 18c-1.65 0-3-1.344-3-3v-4.267c0-1.65 1.343-3 3-3h5.532v-2.61h-5.532c-1.65 0-3-1.344-3-3v-4.267c0-1.65 1.343-3 3-3h5.532v-2.61h-5.532c-1.65 0-3-1.344-3-3v-4.267c0-1.635 1.343-2.979 3-2.979h12.87c1.65 0 3 1.344 3 3v4.267c0 1.65-1.344 3-3 3H.834v2.603h5.603c1.65 0 3 1.344 3 3v4.267c0 1.65-1.344 3-3 3H.834V7.74h5.603c1.65 0 3 1.343 3 3v4.267c0 1.65-1.344 3-3 3h-12.87V18zm0-8.532c-.697 0-1.266.568-1.266 1.265V15c0 .697.569 1.266 1.266 1.266h12.87c.696 0 1.265-.569 1.265-1.266v-4.266c0-.697-.569-1.265-1.265-1.265h-12.87zm0-12.87c-.697 0-1.266.568-1.266 1.265V2.13c0 .696.569 1.265 1.266 1.265h12.87c.696 0 1.265-.569 1.265-1.265v-4.267c0-.697-.569-1.265-1.265-1.265h-12.87zm0-12.87c-.697 0-1.266.569-1.266 1.265v4.267c0 .697.569 1.265 1.266 1.265h12.87c.696 0 1.265-.568 1.265-1.265v-4.267c0-.696-.569-1.265-1.265-1.265h-12.87z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.04 28.74)",
  clipPath: "url(#migrate_svg__b)"
}, /*#__PURE__*/React.createElement("clipPath", {
  id: "migrate_svg__b"
}, /*#__PURE__*/React.createElement("rect", {
  transform: "translate(14.96 -10.74)",
  x: -18,
  y: -18,
  rx: 0,
  ry: 0,
  width: 36,
  height: 36
})), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M2.165 2.994C-.708 2.994-3.04.697-3.04-2.133c0-.476.391-.867.867-.867.477 0 .868.39.868.867 0 1.842 1.593 3.399 3.47 3.399.476 0 .867.391.867.868 0 .476-.39.86-.867.86z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(.87 20.13)",
  clipPath: "url(#migrate_svg__c)"
}, /*#__PURE__*/React.createElement("clipPath", {
  id: "migrate_svg__c"
}, /*#__PURE__*/React.createElement("rect", {
  transform: "translate(17.13 -2.13)",
  x: -18,
  y: -18,
  rx: 0,
  ry: 0,
  width: 36,
  height: 36
})), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M-.003 3a.871.871 0 01-.867-.867v-4.267C-.87-2.61-.479-3-.003-3c.477 0 .868.391.868.867v4.267A.871.871 0 01-.003 3z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(7.3 7.3)",
  clipPath: "url(#migrate_svg__d)"
}, /*#__PURE__*/React.createElement("clipPath", {
  id: "migrate_svg__d"
}, /*#__PURE__*/React.createElement("rect", {
  transform: "translate(10.7 10.7)",
  x: -18,
  y: -18,
  rx: 0,
  ry: 0,
  width: 36,
  height: 36
})), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M-6.433 7.298A.871.871 0 01-7.3 6.43V2.093c0-2.823 2.332-5.127 5.205-5.127h5.674l-4.025-2.68a.87.87 0 01-.37-.548.865.865 0 01.129-.647.87.87 0 011.202-.249l6.399 4.266a.86.86 0 01.384.719.85.85 0 01-.384.718L.514 2.81a.87.87 0 01-.476.142.865.865 0 01-.846-1.031.844.844 0 01.37-.547l4.017-2.68h-5.674c-1.884 0-3.47 1.556-3.47 3.398V6.43a.871.871 0 01-.868.868z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(11.6 30.87)",
  clipPath: "url(#migrate_svg__e)"
}, /*#__PURE__*/React.createElement("clipPath", {
  id: "migrate_svg__e"
}, /*#__PURE__*/React.createElement("rect", {
  transform: "translate(6.4 -12.87)",
  x: -18,
  y: -18,
  rx: 0,
  ry: 0,
  width: 36,
  height: 36
})), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M-2.129.864a.87.87 0 01-.867-.868c0-.476.39-.867.867-.867h4.266c.477 0 .868.39.868.867a.87.87 0 01-.868.868h-4.266z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(26.57 5.13)",
  clipPath: "url(#migrate_svg__f)"
}, /*#__PURE__*/React.createElement("clipPath", {
  id: "migrate_svg__f"
}, /*#__PURE__*/React.createElement("rect", {
  transform: "translate(-8.57 12.87)",
  x: -18,
  y: -18,
  rx: 0,
  ry: 0,
  width: 36,
  height: 36
})), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M-4.3.864a.871.871 0 01-.868-.868c0-.476.391-.86.868-.86h8.603c.477 0 .868.391.868.868a.871.871 0 01-.868.867H-4.3V.864z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(26.57 18)",
  clipPath: "url(#migrate_svg__g)"
}, /*#__PURE__*/React.createElement("clipPath", {
  id: "migrate_svg__g"
}, /*#__PURE__*/React.createElement("rect", {
  transform: "translate(-8.57)",
  x: -18,
  y: -18,
  rx: 0,
  ry: 0,
  width: 36,
  height: 36
})), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M-4.3.864a.87.87 0 01-.868-.868c0-.476.391-.867.868-.867h8.603c.477 0 .868.391.868.867a.87.87 0 01-.868.868H-4.3z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(26.57 30.87)",
  clipPath: "url(#migrate_svg__h)"
}, /*#__PURE__*/React.createElement("clipPath", {
  id: "migrate_svg__h"
}, /*#__PURE__*/React.createElement("rect", {
  transform: "translate(-8.57 -12.87)",
  x: -18,
  y: -18,
  rx: 0,
  ry: 0,
  width: 36,
  height: 36
})), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M-4.3.864a.87.87 0 01-.868-.868c0-.476.391-.867.868-.867h8.603c.477 0 .868.39.868.867a.87.87 0 01-.868.868H-4.3z"
})));

function SvgMigrate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36
  }, props), _ref, _ref2);
}

export default SvgMigrate;